/** Live SportsFutureRegistry deployments (ship: 89898 then 2786). */

export const REGISTRY_DEPLOYER = '0xb1a02681026cFEeFAD337368D2b546C72fcEb068';

/** On-chain operators. Source of truth is AccessControl; this list seeds UI + grants. */
export const REGISTRY_ADMINS = [
  REGISTRY_DEPLOYER,
  '0x35DF663AecA44d466AE11aeE42fFb4ec5f96C6cc',
] as const;

export const SPORTS_FUTURE_REGISTRY = {
  89898: {
    chainId: 89898,
    registry: '0xbe9Ac282F082BD5736879268eD5397Ee69c8064d',
    didNft: '0xC246D58B8A694283e2E867C6aD98692A93d67B9b',
    admins: REGISTRY_ADMINS,
    explorer:
      'https://explorer-testnet.apertum.io/address/0xbe9Ac282F082BD5736879268eD5397Ee69c8064d',
  },
  2786: {
    chainId: 2786,
    registry: '0xa9d1A338DA698AA614F020E323895b16aE2519aB',
    didNft: '0xDE72695e54Bb44bEB1844C35CD3eA50f4F785F2D',
    admins: REGISTRY_ADMINS,
    explorer:
      'https://explorer.apertum.io/address/0xa9d1A338DA698AA614F020E323895b16aE2519aB',
  },
} as const;

export const REGISTRY_ABI = [
  'function register()',
  'function refreshDid() returns (uint256 didId)',
  'function submit(uint8 appRole, bytes32 contentHash, string uri) returns (uint256 id)',
  'function review(uint256 id, uint8 status)',
  'function grantReviewer(address account)',
  'function revokeReviewer(address account)',
  'function getUser(address account) view returns (tuple(uint256 didId, uint64 registeredAt, bool active))',
  'function isRegistered(address account) view returns (bool)',
  'function getApplication(uint256 id) view returns (tuple(address applicant, uint256 didId, uint8 appRole, uint8 status, bytes32 contentHash, string uri, uint64 submittedAt))',
  'function applicationCount() view returns (uint256)',
  'function hasRole(bytes32 role, address account) view returns (bool)',
  'function ADMIN_ROLE() view returns (bytes32)',
  'function REVIEWER_ROLE() view returns (bytes32)',
] as const;
